import React, { useState } from 'react';

import DistanceHelper from './DistanceHelper';
import SwimTime from './SwimTime';
import TransitionTime from './TransitionTime';
import BikeTime from './BikeTime';
import RunTime from './RunTime';
import Result from './Result';

const Calculator = props => {
    const [distance, setDistance] = useState('standard');
    const [times, setTimes] = useState({ swim: 1200, t1: 120, bike: 120, t2: 120, run: 300 });

    const setDisciplineTime = (discipline, seconds) => {
        const newTimes = {...times};
        newTimes[discipline] = seconds;
        setTimes(newTimes);
    }

    return (
        <form className="race-time-calculator">
            <label>
                <p>Begin by selecting the race distance:</p>
                <select value={distance} onChange={event => setDistance(event.target.value)}>
                    <option value="pool-sprint">Pool sprint</option>
                    <option value="sprint">Sprint</option>
                    <option value="standard">Standard</option>
                    <option value="middle">Middle</option>
                    <option value="full">Full</option>
                </select>
            </label>

            <SwimTime callback={setDisciplineTime} />
            <TransitionTime number={1} defaultValue={times.t1} callback={setDisciplineTime} />
            <BikeTime callback={setDisciplineTime} />
            <TransitionTime number={2} defaultValue={times.t2} callback={setDisciplineTime} />
            <RunTime callback={setDisciplineTime} />

            <Result times={times} distance={distance} />
        </form>
    );
};

export default Calculator;
